import React, { useState } from 'react';
import { FaEnvelope, FaWhatsapp, FaTelegram, FaTwitter, FaFacebook, FaLinkedin, FaQrcode, FaCopy } from 'react-icons/fa';
import '../styles/CardinalShareButtons.css';

const CardinalShareButtons = ({ cardinal }) => {
  const [showQR, setShowQR] = useState(false);
  const [copied, setCopied] = useState(false);
  
  // URL actuelle (à remplacer par une URL complète en production)
  const currentUrl = window.location.href;
  
  // Texte pour le partage
  const shareText = `Découvrez le profil de ${cardinal.titreHonorifique} ${cardinal.nomComplet}, cardinal de l'Église catholique`;
  
  // Fonction de partage par email
  const shareByEmail = () => {
    const subject = encodeURIComponent(`Profil du Cardinal ${cardinal.nomComplet}`);
    const body = encodeURIComponent(`${shareText}\n\n${currentUrl}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };
  
  // Fonction de partage WhatsApp
  const shareByWhatsApp = () => {
    const text = encodeURIComponent(`${shareText}\n\n${currentUrl}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };
  
  // Fonction de partage Telegram
  const shareByTelegram = () => {
    const text = encodeURIComponent(`${shareText}\n\n${currentUrl}`);
    window.open(`https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${text}`, '_blank');
  };
  
  // Fonction de partage Twitter
  const shareByTwitter = () => {
    const text = encodeURIComponent(shareText);
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(currentUrl)}`, '_blank');
  };
  
  // Fonction de partage Facebook
  const shareByFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`, '_blank');
  };
  
  // Fonction de partage LinkedIn
  const shareByLinkedIn = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`, '_blank');
  };
  
  // Fonction pour copier le lien
  const copyLink = () => {
    navigator.clipboard.writeText(currentUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };
  
  // Fonction pour afficher/masquer le QR code
  const toggleQR = () => {
    setShowQR(!showQR);
  };
  
  return (
    <div className="cardinal-share-container">
      <h3>Partager ce profil</h3>
      
      <div className="share-buttons">
        <button onClick={shareByEmail} className="share-button email" title="Partager par email">
          <FaEnvelope />
        </button>
        
        <button onClick={shareByWhatsApp} className="share-button whatsapp" title="Partager via WhatsApp">
          <FaWhatsapp />
        </button>
        
        <button onClick={shareByTelegram} className="share-button telegram" title="Partager via Telegram">
          <FaTelegram />
        </button>
        
        <button onClick={shareByTwitter} className="share-button twitter" title="Partager sur Twitter">
          <FaTwitter />
        </button>
        
        <button onClick={shareByFacebook} className="share-button facebook" title="Partager sur Facebook">
          <FaFacebook />
        </button>
        
        <button onClick={shareByLinkedIn} className="share-button linkedin" title="Partager sur LinkedIn">
          <FaLinkedin />
        </button>
        
        <button onClick={toggleQR} className="share-button qrcode" title="Afficher le QR code">
          <FaQrcode />
        </button>
      </div>
      
      <div className="copy-link">
        <input type="text" value={currentUrl} readOnly />
        <button onClick={copyLink} title="Copier le lien">
          <FaCopy /> {copied ? "Copié !" : "Copier"}
        </button>
      </div>
      
      {showQR && (
        <div className="qr-code-container">
          <img 
            src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(currentUrl)}`} 
            alt="QR Code" 
          />
        </div>
      )}
    </div>
  );
};

export default CardinalShareButtons;